export { Globals } from '@axisnow/readium-shared-js';